export default __webpack_public_path__ + "static/media/shan.ae85e331.jpeg";